"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargePointsResponse = exports.ChargePoint = exports.ChargePointLocation = exports.Connector = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const ChargePointModel_1 = require("./enums/ChargePointModel");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class Connector extends base_models_1.Serializable {
}
exports.Connector = Connector;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Index', defaultValue: 0 }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], Connector.prototype, "index", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Connector State', example: 'active' }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], Connector.prototype, "connectorState", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'evseId', example: 'NL-ESS-E00003469' }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], Connector.prototype, "evseId", void 0);
class ChargePointLocation extends base_models_1.Serializable {
}
exports.ChargePointLocation = ChargePointLocation;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Address', example: 'Nijmegen' }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargePointLocation.prototype, "address", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'City', example: 'Nijmegen' }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargePointLocation.prototype, "city", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Postal code', example: '5467PK' }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargePointLocation.prototype, "postalCode", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Country', example: 'Netherlands' }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargePointLocation.prototype, "country", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Lat', example: 90 }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ChargePointLocation.prototype, "lat", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Lon', example: 180 }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], ChargePointLocation.prototype, "lon", void 0);
class ChargePoint extends base_models_1.Serializable {
}
exports.ChargePoint = ChargePoint;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Public Identifier', example: 'xyz-awe' }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargePoint.prototype, "publicIdentifier", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'ocpiId', example: 'NL-ESS-S00002996' }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], ChargePoint.prototype, "ocpiId", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        description: 'ChargePointLocation',
        example: {
            address: 'Nijmegen',
            city: 'Nijmegen',
            postalCode: '5467PK',
            country: 'Netherlands',
            lat: 90,
            lon: 180,
        },
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => ChargePointLocation),
    tslib_1.__metadata("design:type", ChargePointLocation)
], ChargePoint.prototype, "location", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(ChargePointModel_1.ChargePointModel),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'Charge point model',
        example: ChargePointModel_1.ChargePointModel.ProLine,
    }),
    tslib_1.__metadata("design:type", String)
], ChargePoint.prototype, "model", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        description: 'Charge point registration date',
        example: '2024-03-04T12:15:24',
    }),
    tslib_1.__metadata("design:type", String)
], ChargePoint.prototype, "registrationDate", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'Connectors', example: [{ index: 0, connectorState: 'activated' }] }),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => Connector),
    tslib_1.__metadata("design:type", Array)
], ChargePoint.prototype, "connectors", void 0);
class ChargePointsResponse extends base_models_1.Serializable {
}
exports.ChargePointsResponse = ChargePointsResponse;
tslib_1.__decorate([
    (0, base_models_1.Docs)({
        example: [
            {
                publicIdentifier: 'xyz-awe',
                location: {
                    address: 'Nijmegen',
                    city: 'Nijmegen',
                    postalCode: '5467PK',
                    country: 'Netherlands',
                    lat: 90,
                    lon: 180,
                },
                connectors: [
                    {
                        index: 0,
                        connectorState: 'activated',
                    },
                ],
                model: ChargePointModel_1.ChargePointModel.ProLine,
                registrationDate: '2024-03-04T12:15:24',
            },
        ],
        description: 'Charge Points',
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ChargePoint),
    tslib_1.__metadata("design:type", Array)
], ChargePointsResponse.prototype, "results", void 0);
